
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // If user is already authenticated, redirect to intended destination or account page
  if (user) {
    const from = location.state?.from?.pathname || '/account';
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};

export default AuthRoute;
